import { PracticeContentDataFields } from '@cibo/core'
import { createContext, useContext } from 'react'

export interface PracticeDrawerState {
  open: boolean
  practice?: PracticeContentDataFields
  selectInteraction:
    | false
    | {
        onClickSelect: ({ label, value }: { label: string; value: string }) => void
        currentPracticeIsSelected: boolean
      }
}

export interface PracticeDrawerContextType {
  drawerState: PracticeDrawerState
  setDrawerState: (state: PracticeDrawerState) => void
}

export const DEFAULT_VALUES = {
  drawerState: {
    open: false,
    practice: undefined,
    selectInteraction: {
      onClickSelect: () => console.log('PracticeDrawerContext onClickSelect is not defined'),
      currentPracticeIsSelected: false,
    },
  },
  setDrawerState: () => {},
}

export const PracticeDrawerContext = createContext<PracticeDrawerContextType>(DEFAULT_VALUES)
PracticeDrawerContext.displayName = 'PracticeDrawerContext'

export const usePracticeDrawer = () => useContext(PracticeDrawerContext)
